export const CustomMuiCssBaseline = {
    styleOverrides: {
      html: {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      body: {
        transition: 'all 0.25s ease-in-out',
      },
      root: {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
    }
}